<template>

<com-item name="game.plays.calendar" :size="size" :loading="loading" :is-empty="!active" title="Calendar">

	<template v-slot:about>

		<p>When {{ you }} played this game.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-bars :data="graph" v-if="active" />

	</template>

	<template v-slot:buttons>

		<com-toggle :options="typeOptions" :value="typeValue" v-on:change="onTypeChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	data: function() {

		return {
			type: 'days',
			graph: {
				datasets: [
					{ type: 'bar', data: [], backgroundColor: '#4881bb', tooltip: '{{value}} play{{value.plural}} <small>{{x.label}} {{x.sublabel}}</small>' }
				],
				axis: {
					x: {
						labels: []
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		plays: function() {

			return this.$store.getters['page/insights/game/plays']

		},

		active: function() {

			return this.plays && this.plays.byDayOfWeek && this.plays.byDayOfWeek.length && !this.loading

		},

		typeOptions: function() {

			return [
				{ value: 'days', text: 'By Day of Week' },
				{ value: 'months', text: 'By Month' },
				{ value: 'years', text: 'By Year' }
			]

		},

		typeValue: function() {

			return this.type

		}

	},

	watch: {

		plays: function() {

			this.visualise()

		}

	},

	created: function() {

		this.visualise()

	},

	methods: {

		onTypeChange: function(value) {

			this.type = value
			this.visualise()

		},

		visualise: function() {

			if (!this.plays || !this.plays.byDayOfWeek) return

			this.graph.datasets[0].data = []
			this.graph.axis.x.labels = []

			if (this.type === 'days') {

				this.$_.each(this.plays.byDayOfWeek, function(item) {

					this.graph.axis.x.labels.push(item.day)
					this.graph.datasets[0].data.push(item.plays)

				}.bind(this))

			} else if (this.type === 'months') {

				this.$_.each(this.plays.seasonality, function(item) {

					this.graph.axis.x.labels.push(item.month)
					this.graph.datasets[0].data.push(item.plays)

				}.bind(this))

			} else if (this.type === 'years') {

				this.$_.each(this.plays.byYear, function(item) {

					this.graph.axis.x.labels.push(item.year)
					this.graph.datasets[0].data.push(item.plays)

				}.bind(this))

			}

		}

	}

}

</script>

<style scoped>

</style>
